import {
  Component,
  forwardRef,
  Inject,
  Input,
  OnInit
}                             from '@angular/core';
import { NgbActiveModal }     from '@ng-bootstrap/ng-bootstrap';
import { NgForm }             from '@angular/forms';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { TranslateService }   from '@ngx-translate/core';

import { AccountingChangeOptionsModel } from './typings/admin-dashboard.accounting-change.options';
import { AdminDashboardService }        from './admin-dashboard.service';
import { CodeTypeModel }                from '../core/models/code-type';
import { ConfirmService }               from '../messages/confirm/confirm.service';
import { MessagesService }              from '../messages/messages.service';
import { SessionService }               from '../sessions/session.service';

@Component({
  template: require('./admin-dashboard.change-accounting.component.html'),
  selector   : 'wor-admin-dashboard-change-accounting'
})
export class ChangeAccountingComponent implements OnInit {
  @BlockUI('changeAccountingBlock') block : NgBlockUI;

  @Input() company : any;

  invoiceOptions: Array<CodeTypeModel> = this.adminDashboardService.getAccountingChangeInvoiceOptions();
  options       : AccountingChangeOptionsModel;
  packages      : Array<CodeTypeModel> = this.adminDashboardService.getAccountingChangePackages();

  constructor (
    public  activeModal           : NgbActiveModal,
    @Inject(forwardRef(() => AdminDashboardService))
    private adminDashboardService : AdminDashboardService,
    private confirmService        : ConfirmService,
    private messagesService       : MessagesService,
    private sessionService        : SessionService,
    private translateService      : TranslateService
  ) {}

  canSelectDate () : boolean {
    return this.options.option === 'B';
  }

  confirm ( form : NgForm ) : void {
    this.confirmService.generic(this.translateService.instant('JS_SPACE.CONFIRM.CONFIRM_ACCOUNTING_CHANGE'))
    .then(() => {
      this.block.start();

      return this.adminDashboardService.confirmAccountingChange(this.options);
    })
    .then(( response : any ) => {
      this.messagesService.show(response.message, 'success');

      this.activeModal.close();
    })
    .catch(error => this.messagesService.error(error))
    .finally(() => this.block.stop());
  }

  ngOnInit () : void {
    this.options = {
      company_id         : this.company.id,
      current_package    : this.packages.length ? this.packages[ 0 ].code : '',
      include_outstanding: false,
      option             : this.invoiceOptions.length ? this.invoiceOptions[ 0 ].code : '',
      start_date         : null,
      target_package     : this.packages.length ? this.packages[ 0 ].code : '',
      user_id            : this.sessionService.user().id,
    };
  }

  onOptionChange () : void {
    this.options.start_date = null;
  }
}
